// AWS analytics functions

/*

import uuid from 'uuid/v1'

function getUUID () {
  let sessionId = null
  try{
    sessionId = JSON.parse(localStorage.getItem('freshy_sessionId'))
  }
  catch(e) {
      sessionId = null
  }
  if (!sessionId) {
    sessionId = { id: uuid(), isGuid: false }
    localStorage.setItem('freshy_sessionId', JSON.stringify(sessionId))
  }
  
  return sessionId
}
*/

import { getTypeTag } from "@/common";
// Our Events endpoint /api/events

function trackGA(event_name, event_params) {
    gtag("event", event_name, event_params);
}

async function pageviewEvent(vertical = null, label = null, typeTag = null) {
    // let id = getUUID()
    const body = {
        event: "pageview",
        // id: id.id,
        // extensionUser: id.isGuid
    };
    if (document.referrer) body.referrer = document.referrer;
    if (vertical) body.vertical = vertical;
    if (label) body.label = label;
    if (typeTag) body.type = getTypeTag(typeTag);

    fetch("/api/events", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    });
}

function searchEvent(searchTerm, vertical = null, typeTag = null) {
    if (searchTerm) {
        // let id = getUUID()
        const body = {
            event: "search",
            // id: id.id,
            // extensionUser: id.isGuid
            searchTerm,
        };
        if (document.referrer) body.referrer = document.referrer;
        if (vertical) body.vertical = vertical;
        if (typeTag) body.type = getTypeTag(typeTag);

        fetch("/api/events", {
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
    }
}

async function clickEvent(
    vertical = null,
    action = null,
    label = null,
    typeTag = null
) {
    // let id = getUUID()
    const body = {
        event: "click",
        // id: id.id,
        // extensionUser: id.isGuid,
    };
    if (document.referrer) body.referrer = document.referrer;
    if (vertical) body.vertical = vertical;
    if (action) body.action = action;
    if (label) body.label = label;
    if (typeTag) body.type = getTypeTag(typeTag);

    fetch("/api/events", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    });
}

// fresh forever yahoo xml reporting staging.freshforever.services

// Type 1=search 2=ad click 3=organic click
function yahooXMLClickEvent(type, searchInfo) {
    fetch(
        `/xml/ping.php?q=${searchInfo.keyword}&source_tag=${
            searchInfo.source_tag
        }&type_tag=${getTypeTag(searchInfo.type_tag)}&site=${
            searchInfo.site
        }&etype=${type}&user_country=${searchInfo.user_country}&market=${
            searchInfo.market
        } &search_action=${searchInfo.search_action || "default_search"}`
    );
}

export { pageviewEvent, searchEvent, clickEvent, yahooXMLClickEvent, trackGA };
